import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

// Use relative URL for API calls - works on any domain including production
const getApiUrl = () => {
  // In production and preview, use relative URLs (empty string)
  // The backend is served from the same domain
  return '';
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    // Check if user is already logged in
    const authStatus = localStorage.getItem("jglinks_auth");
    const storedCreds = localStorage.getItem("jglinks_creds");
    if (authStatus === "true" && storedCreds) {
      setIsAuthenticated(true);
      setCredentials(JSON.parse(storedCreds));
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await fetch(`${getApiUrl()}/api/auth/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return { success: false, error: errorData.detail || "Error de autenticación" };
      }
      
      const data = await response.json();
      
      if (data.success) {
        setIsAuthenticated(true);
        setCredentials({ username, password });
        localStorage.setItem("jglinks_auth", "true");
        localStorage.setItem("jglinks_creds", JSON.stringify({ username, password }));
        return { success: true };
      }
      
      return { success: false, error: data.message || "Credenciales incorrectas" };
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, error: "Error de conexión al servidor" };
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setCredentials(null);
    localStorage.removeItem("jglinks_auth");
    localStorage.removeItem("jglinks_creds");
  };
  
  // Helper to get auth headers for API calls
  const getAuthHeaders = () => {
    if (credentials) {
      return {
        "Authorization": "Basic " + btoa(`${credentials.username}:${credentials.password}`)
      };
    }
    return {};
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout, getAuthHeaders, credentials }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
